import e from "./_getNative.js";
var t = e(Object, "create");
const r = t;
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_nativeCreate.js
// module id = 313
// module chunks = 67